import { BaseOptionsListModel } from "./base.model"

export class OptionTypeDeliveryModel {
  id: string
  title: string
  is_enabled: boolean
  type: string
  options: string[]
  constructor(obj: any = null) {
    this.id = obj?.id
    this.is_enabled = obj?.is_enabled || false
    this.type = obj?.type
    this.options = obj?.options
    this.title = obj?.title
  }

  getTitle(): string {
    if (this.id == 'address') {
      return 'DELIVERY_METHOD.ADDRESS'
    }
    if (this.id == 'microdelivery') {
      return 'Microdelivery'
    }
    if (this.id == 'microdelivery2') {
      return 'Microdelivery'
    }
    if (this.id == 'bar') {
      return 'DELIVERY_METHOD.COUNTER2'
    }
    if (this.id == 'table') {
      return 'DELIVERY_METHOD.TABLE2'
    }
    return ''
  }
}
class DeliverySettingModel {
  cost: number
  min_total: number
  now: boolean
  scheduled: boolean
  options: OptionTypeDeliveryModel[]

  constructor(obj: any = null) {
    this.cost = obj?.cost || 0
    this.min_total = obj?.min_total || 0
    this.now = obj?.now || false
    this.scheduled = obj?.scheduled || false
    this.options = obj?.options ? obj?.options.map((i: any) => (new OptionTypeDeliveryModel(i))) : []
  }
}

class DeliveryMethodDetailModel {
  is_enabled: boolean
  settings: DeliverySettingModel

  constructor(obj: any = null) {
    this.is_enabled = obj?.is_enabled || false
    this.settings = new DeliverySettingModel(obj?.settings)
  }
}

export class DeliveryMethodsModel {
  [key: string]: any;
  pickup: DeliveryMethodDetailModel
  counter: DeliveryMethodDetailModel
  delivery: DeliveryMethodDetailModel
  table: DeliveryMethodDetailModel
  roomservice: DeliveryMethodDetailModel

  constructor(obj: any = null) {
    this.pickup = new DeliveryMethodDetailModel(obj?.pickup)
    this.counter = new DeliveryMethodDetailModel(obj?.counter)
    this.delivery = new DeliveryMethodDetailModel(null)
    this.table = new DeliveryMethodDetailModel(obj?.table)
    this.roomservice = new DeliveryMethodDetailModel(null)
  }

  getListEnabled(): BaseOptionsListModel[] {
    let list = []


    if (this.table.is_enabled) {
      list.push({
        id: 'table',
        title: 'DELIVERY_METHOD.TABLE',
        icon: '🍽️'
      })
    }

    if (this.counter.is_enabled && this.counter.settings.now) {
      list.push({
        id: 'counter',
        title: 'DELIVERY_METHOD.DINE_IN',
        icon: '🍽️'
      })
    }

    if (this.pickup.is_enabled && this.pickup.settings.now) {
      list.push({
        id: 'pickup',
        title: 'DELIVERY_METHOD.PICKUP',
        icon: '🏃‍♀️'
      })
    }

    if (this.roomservice.is_enabled) {
      list.push({
        id: 'roomservice',
        title: 'Roomservice',
        icon: '🏃‍♀️'
      })
    }

    if (this.delivery.is_enabled) {
      list.push({
        id: 'delivery',
        title: 'Delivery',
        icon: '🏃‍♀️'
      })
    }

    return list
  }
}
